import { useEffect, useState } from "react";
import { GridLoader } from "react-spinners";
import Certificates from "./Components/Certificates/Certificates";
import Contact from "./Components/Contact/Contact";
// import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";
import DotGroup from "./Components/DotGroup/DotGroup";
import Footer from "./Components/Footer/Footer";
import Landing from "./Components/Landing/Landing";
import LineHr from "./Components/Line/LineHr";
import Navbar from "./Components/Navbar/Navbar";
import Projects from "./Components/Projects/Projects";
import Skills from "./Components/Skills/Skills";
import useMediaQuery from "./Hooks/useMediaQuery";

function App() {
  const [selectedPage, SetselectedPage] = useState("home");
  const isAboveMediumSize = useMediaQuery("(min-width:1060px)");
  const [isTopRoot, SetisTopRoot] = useState(true);
  const [isLoading, SetisLoading] = useState(true);
  useEffect(() => {
    // SetisLoading(true);
    setTimeout(() => {
      SetisLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) SetisTopRoot(true);
      if (window.scrollY !== 0) SetisTopRoot(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div>
      {isLoading ? (
        <div className="flex flex-col items-center justify-center h-screen bg-red ">
          <GridLoader size={15} color="white" loading={isLoading} />
          <p className=" font-poppins font-semibold mt-5 text-3xl text-center sm:text-3xl">
            I'm a full-stack developer `MKD`
          </p>
        </div>
      ) : (
        <div className="app">
          <Navbar
            isTopRoot={isTopRoot}
            selectedPage={selectedPage}
            SetselectedPage={SetselectedPage}
          />

          <div className="w-5/6 mx-auto md:h-full">
            {isAboveMediumSize && (
              <DotGroup
                selectedPage={selectedPage}
                SetselectedPage={SetselectedPage}
              />
            )}
            <Landing SetselectedPage={SetselectedPage} />
            <LineHr />
            <Skills />
            <LineHr />
            <Projects />
            <LineHr />
            <Certificates />
            <LineHr />
            <Contact />
          </div>
          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
